import { OpenGovAppConfig } from '@opengov/app-config';
import React, { useEffect, useState } from 'react';
import { IStoryListMessages } from '../../../../../types';

import styles from './GoogleSignInButton.scss';

export interface IGoogleSignInButtonProps {
  messages: IStoryListMessages;
  handleCredentialResponse: any;
}

export const GoogleSignInButton: React.FC<IGoogleSignInButtonProps> = (props) => {
  const { messages, handleCredentialResponse } = props;
  const [client, setClient] = useState(null);
  const initializeGoogleTokenClient = () => {
    setClient(
      google.accounts.oauth2.initTokenClient({
        client_id: OpenGovAppConfig.GOOGLE_API_CLIENT_ID,
        scope: 'https://www.googleapis.com/auth/analytics.readonly',
        prompt: 'select_account',
        callback: handleCredentialResponse
      })
    );
  };

  useEffect(() => {
    if (!client) {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        initializeGoogleTokenClient();
      };
      document.body.appendChild(script);

      // Clean up the script on component unmount
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [client]);

  return (
    <>
      <div
        id="google-analytics-auth-button"
        role="button"
        className={styles.gsignin}
        onClick={() => client && client.requestAccessToken()}
      >
        <span className={styles.icon} />
        <span className={styles.buttonText}>{messages.signInWithGoogle}</span>
      </div>
    </>
  );
};
